<div>
  @if (errorMessage(); as errorMessage) {
    <myarvato-error-message
      [summary]="errorMessage.summary | translate"
      [details]="errorMessage.detail | translate"
      class="mb-4"
    ></myarvato-error-message>
  }

  @if (handlingUnits(); as handlingUnits) {
    @if (handlingUnits.length > 1) {
      <div class="upload-document__container mb-4">
        <transport-multi-unit-selection
          [handlingUnits]="handlingUnits"
          [selectedHandlingUnits]="[initialHandlingUnit()]"
          (selectedHandlingUnitsChange)="selectedHandlingUnits.set($event)"
        ></transport-multi-unit-selection>
      </div>
    }
  }
  <div
    class="upload-document__container"
    transportFileDropZone
    dragClass="upload-document__drop-zone--active"
    (fileDropped)="selectedFile.set($event)"
  >
    <h2 class="upload-document__headline">{{ 'pages.transport.upload-dialog.drop-file-info-text' | translate }}</h2>

    <transport-expandable-info-text
      [shortText]="'pages.transport.upload-dialog.info-text-short' | translate"
      [longText]="'pages.transport.upload-dialog.info-text-long' | translate"
    ></transport-expandable-info-text>

    <transport-select-file class="my-3" [selectedFile]="selectedFile()" (fileSelected)="selectedFile.set($event)" />

    <p-floatlabel variant="on">
      <p-select
        id="documentType"
        [options]="allowedDocumentTypes()"
        [(ngModel)]="selectedDocumentType"
        appendTo="body"
        fluid
        scrollHeight="300px"
      >
        <ng-template #selectedItem let-item>
          {{ item }} - {{ 'pages.transport.upload-dialog.file-types.' + item | translate }}
        </ng-template>

        <ng-template #item let-item> {{ item }} - {{ 'pages.transport.upload-dialog.file-types.' + item | translate }} </ng-template>
      </p-select>

      <label for="documentType" class="file-type-select__label form-label">
        {{ 'pages.transport.upload-dialog.select-file-type' | translate }}
      </label>
    </p-floatlabel>
  </div>

  <div class="d-flex justify-content-end gap-4 mt-4">
    <p-button icon="pi pi-times" [label]="'general.cancel' | translate" (onClick)="cancel()" severity="secondary" />
    <p-button
      type="submit"
      icon="pi pi-save"
      [label]="'pages.transport.upload-dialog.buttons.save' | translate"
      (onClick)="uploadFile()"
      [disabled]="!isFormValid()"
    />
  </div>
</div>
